import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';

interface IPageTP0002 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Tp0002Controller(Menu: IMenuClass) {
    const vm: IPageTP0002 = this;

    vm.multiOccurrenceOptions = {
        //navigatePage: ????Route.NAME,
        actionsNouveaux: new Menu([]),
        colonnesVisibles: [
            {nom: 'ktfcod', largeur: 200},
            {nom: 'ktfdscabr', largeur: 200},
            {nom: 'ktfdsc', largeur: 200},
            {nom: 'vaektfcnd_dsc', largeur: 200},
            {nom: 'ktfflgact', largeur: 200}
        ]
    };
}
